module.exports = __webpack_public_path__ + "static/media/LancamentosFinanceiros5.6a7f982a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancLancamentosFinanceiros/LancamentosFinanceiros5.png
// module id = 2154
// module chunks = 0